import DocumentPage from "../../../../invoice/DocumentPage";
import { verifactuRegularInvoiceConfig } from "./config";

const VerifactuRegularInvoice = () => (
  <DocumentPage config={verifactuRegularInvoiceConfig} />
);

export default VerifactuRegularInvoice;
